enum ProcessedCallActions {
  SET_STATE,
  SET_LOADING,
  UPDATE_QUEUED_AT,
}

export { ProcessedCallActions };
